import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NeutraNavbar from '@/components/feature/NeutraNavbar';
import NeutraFooter from '@/components/feature/NeutraFooter';

const cases = [
  {
    id: 1,
    name: 'Roofing Company — Riverside',
    image: 'https://public.readdy.ai/ai/img_res/6ea78823d573cd8c4ab191d7d77dd265.jpg',
    tags: ['Agency', 'Web Design', 'SEO'],
  },
  {
    id: 2,
    name: 'Medical Spa — Los Angeles',
    image: 'https://readdy.ai/api/search-image?query=luxury%20medical%20spa%20beauty%20wellness%20website%20displayed%20on%20laptop%20screen%2C%20elegant%20soft%20beige%20minimal%20UI%2C%20premium%20brand%20identity%20design%2C%20professional%20web%20screenshot%20on%20white%20background&width=800&height=560&seq=nc02&orientation=landscape',
    tags: ['Business', 'Branding', 'E-Commerce'],
  },
  {
    id: 3,
    name: 'HVAC Services — Inland Empire',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20heating%20cooling%20services%20company%20website%20on%20laptop%20screen%2C%20clean%20professional%20blue%20white%20UI%2C%20home%20services%20contractor%20web%20design%2C%20modern%20screenshot%20on%20white%20background&width=800&height=560&seq=nc03&orientation=landscape',
    tags: ['Business', 'AI', 'Local SEO'],
  },
  {
    id: 4,
    name: 'Restaurant — San Diego',
    image: 'https://readdy.ai/api/search-image?query=upscale%20restaurant%20dining%20website%20on%20laptop%20screen%2C%20dark%20elegant%20UI%20with%20food%20photography%2C%20online%20menu%20ordering%20system%2C%20San%20Diego%20fine%20dining%20web%20design%20screenshot&width=800&height=560&seq=nc04&orientation=landscape',
    tags: ['Agency', 'Portfolio', 'Social Media'],
  },
  {
    id: 5,
    name: 'Law Firm — High Desert',
    image: 'https://readdy.ai/api/search-image?query=professional%20law%20firm%20attorney%20website%20on%20laptop%20screen%2C%20clean%20minimal%20dark%20navy%20white%20UI%2C%20legal%20services%20web%20design%2C%20lead%20capture%20forms%2C%20professional%20screenshot%20on%20white%20background&width=800&height=560&seq=nc05&orientation=landscape',
    tags: ['Business', 'AI', 'Lead Capture'],
  },
  {
    id: 6,
    name: 'Landscaping Co. — Orange County',
    image: 'https://readdy.ai/api/search-image?query=landscaping%20outdoor%20services%20company%20website%20on%20laptop%20screen%2C%20clean%20modern%20green%20white%20UI%2C%20portfolio%20project%20gallery%2C%20premium%20outdoor%20services%20web%20design%20screenshot&width=800&height=560&seq=nc06&orientation=landscape',
    tags: ['Agency', 'Portfolio', 'SMS'],
  },
  {
    id: 7,
    name: 'Auto Detailing — Temecula',
    image: 'https://readdy.ai/api/search-image?query=luxury%20auto%20detailing%20car%20care%20website%20on%20laptop%20screen%2C%20sleek%20dark%20minimal%20UI%2C%20premium%20car%20detailing%20brand%2C%20modern%20booking%20system%20web%20design%20screenshot%20on%20white%20background&width=800&height=560&seq=nc07&orientation=landscape',
    tags: ['Business', 'Booking', 'Local SEO'],
  },
  {
    id: 8,
    name: 'Dental Office — Rancho Cucamonga',
    image: 'https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20healthcare%20website%20on%20laptop%20screen%2C%20clean%20white%20minimal%20UI%2C%20professional%20dentist%20practice%20web%20design%2C%20patient%20booking%20system%20screenshot%20on%20white%20background&width=800&height=560&seq=nc08&orientation=landscape',
    tags: ['Business', 'AI', 'Branding'],
  },
  {
    id: 9,
    name: 'Plumbing Services — San Bernardino',
    image: 'https://readdy.ai/api/search-image?query=plumbing%20services%20company%20website%20on%20laptop%20screen%2C%20clean%20professional%20UI%2C%20home%20repair%20contractor%20web%20design%2C%20modern%20minimal%20layout%20screenshot%20on%20white%20background&width=800&height=560&seq=nc09&orientation=landscape',
    tags: ['Agency', 'Web Design', 'AI'],
  },
  {
    id: 10,
    name: 'Fitness Studio — Chino Hills',
    image: 'https://readdy.ai/api/search-image?query=modern%20fitness%20gym%20studio%20website%20on%20laptop%20screen%2C%20bold%20dark%20energetic%20UI%2C%20class%20booking%20system%2C%20health%20wellness%20brand%20web%20design%20screenshot%20on%20white%20background&width=800&height=560&seq=nc10&orientation=landscape',
    tags: ['Business', 'Booking', 'Branding'],
  },
];

const faqItems = [
  {
    q: 'How long does a project take?',
    a: 'Most websites are designed, built, and launched within 7–14 days. AI automation setups typically take an additional 3–5 days.',
  },
  {
    q: 'What industries do you work with?',
    a: 'We specialize in local service businesses across Southern California — contractors, medical, legal, hospitality, and more.',
  },
  {
    q: 'Do you offer ongoing support?',
    a: 'Yes. All clients receive ongoing maintenance, updates, and AI monitoring as part of their monthly plan.',
  },
  {
    q: 'What makes NOVA AI DIGITAL different?',
    a: 'We combine beautiful web design with real AI automation — so your site doesn\'t just look good, it actively brings in and converts customers.',
  },
  {
    q: 'Can I see results before committing?',
    a: 'Absolutely. We offer a free strategy call and mockup so you can see exactly what we\'ll build before any payment.',
  },
  {
    q: 'What is included in the AI Receptionist?',
    a: '24/7 chat and SMS handling, appointment booking, lead qualification, and automated follow-up sequences — all trained on your business.',
  },
];

export default function CasesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-white"
      style={{ fontFamily: '\'DM Sans\', sans-serif' }}
    >
      <NeutraNavbar />

      <main>
        {/* Spacer for fixed navbar */}
        <div className="h-20" />

        {/* Page Header — exactly like Neutra: title left, description right */}
        <section className="w-full px-6 md:px-12 lg:px-20 pt-16 pb-14 md:pt-20 md:pb-16">
          <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
            <h1
              className="text-black"
              style={{
                fontWeight: 700,
                fontSize: 'clamp(2.2rem, 5vw, 4rem)',
                letterSpacing: '-0.03em',
                lineHeight: 1.1,
              }}
            >
              Case Studies
            </h1>
            <p
              className="text-black/50 text-sm leading-relaxed max-w-[280px] lg:pt-2"
            >
              Discover the innovative marketing strategies that set NOVA AI DIGITAL apart, driving success in the digital landscape.
            </p>
          </div>
        </section>

        {/* Cases Grid — no borders, no arrows, just image + name + tags */}
        <section className="w-full px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
          <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-14">
            {cases.map(c => (
              <div key={c.id} className="group cursor-pointer">
                {/* Image */}
                <div
                  className="w-full overflow-hidden rounded-xl mb-4"
                  style={{ height: 300 }}
                >
                  <img
                    src={c.image}
                    alt={c.name}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                  />
                </div>

                {/* Name */}
                <h3
                  className="text-black mb-3"
                  style={{
                    fontWeight: 600,
                    fontSize: '1rem',
                    letterSpacing: '-0.01em',
                  }}
                >
                  {c.name}
                </h3>

                {/* Tags */}
                <div className="flex items-center gap-2 flex-wrap">
                  {c.tags.map(tag => (
                    <span
                      key={tag}
                      className="border border-black/20 rounded-full px-3 py-0.5 text-xs text-black/60"
                      style={{ fontWeight: 400 }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ Section — exactly like Neutra template */}
        <section className="w-full bg-[#f5f5f5] px-6 md:px-12 lg:px-20 py-20 md:py-28">
          <div className="max-w-[1200px] mx-auto">
            {/* FAQ Header */}
            <div className="flex flex-col items-center text-center mb-14">
              <p
                className="text-black/40 text-xs uppercase tracking-widest mb-4"
                style={{ letterSpacing: '0.15em' }}
              >
                FAQ
              </p>
              <h2
                className="text-black mb-3"
                style={{
                  fontWeight: 700,
                  fontSize: 'clamp(1.8rem, 4vw, 3rem)',
                  letterSpacing: '-0.03em',
                  lineHeight: 1.15,
                }}
              >
                Explore Our FAQs
              </h2>
              <p className="text-black/45 text-sm leading-relaxed max-w-sm">
                Find quick answers to commonly asked questions about NOVA AI DIGITAL.
                Have a question not listed?
              </p>
            </div>

            {/* FAQ Grid — 3 columns like Neutra */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-10">
              {faqItems.map((item, i) => (
                <div key={i}>
                  <h4
                    className="text-black mb-2"
                    style={{ fontWeight: 600, fontSize: '0.9rem', letterSpacing: '-0.01em' }}
                  >
                    {item.q}
                  </h4>
                  <p className="text-black/50 text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              ))}
            </div>

            {/* Contact link */}
            <div className="flex justify-center mt-14">
              <Link
                to="/contact"
                className="px-7 py-3 rounded-full border border-black/20 text-black text-sm font-medium hover:bg-black hover:text-white hover:border-black transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </section>
      </main>

      <NeutraFooter />
    </div>
  );
}
